import { useClass } from '@/hooks/useClass'

import { IconChevronDown, IconChevronUp, IconWrapper } from '../Icon'

import { OutlinedButton } from './OutlinedButton'

type ToggleButtonProps = React.ComponentProps<'button'> & {
  isOpen: boolean
}

export const ToggleButton = ({
  isOpen,
  className,
  children,
  ...props
}: ToggleButtonProps) => {
  const buttonClass = useClass(
    'flex justify-center items-center !w-[92px] h-[32px]',
    className
  )

  return (
    <OutlinedButton className={buttonClass} {...props}>
      {children}
      <IconWrapper className="ml-4 text-md fill-primary">
        {isOpen ? <IconChevronUp /> : <IconChevronDown />}
      </IconWrapper>
    </OutlinedButton>
  )
}
